import { Tab } from 'bootstrap'
import React, { useContext } from 'react'
import { Container, Tabs } from 'react-bootstrap'
import { CommunityContext } from '../CommunityContext'
import CommunityRequestList from './CommunityRequestList'
import CommunityUpdate from './CommunityUpdate'
import RemoveMember from './RemoveMember'

const CommunitySettings = () => {
  const { communityData } = useContext(CommunityContext)
  
  return (
    <Container id="create-community">
    <Tabs defaultActiveKey="update" id="uncontrolled-tab-example" className="mb-3">
      <Tab eventKey="update" title="Update Community Profile">
        <CommunityUpdate communityData={communityData}/>
      </Tab>
      <Tab eventKey="requests" title="Approve Requests">
        <CommunityRequestList communityData={communityData}/>
      </Tab>
      <Tab eventKey="remove" title="Remove Member">
        <RemoveMember communityData={communityData}/>
      </Tab>
    </Tabs>
      
    </Container>
  )
}

export default CommunitySettings